import React, { useEffect, useState } from 'react';
import "./InvoiceDetailsTab.scss";
import moment from 'moment';
import { DATE_FORMAT } from '../../../../Utils/Constants';
import { getCCInvoiceAmounts } from '../../../../Utils/ccInvoiceAmounts';

const InvoiceDetailsTab = ({ invoice }) => {

    const [isPaidState, setIsPaidState] = useState(invoice?.paid_status === 1);
    const [localPaidRef, setLocalPaidRef] = useState(invoice?.paid_ref_no || '');
    const [localPaidDate, setLocalPaidDate] = useState(invoice?.paid_datetime?.slice(0, 10) || '');

    useEffect(() => {
        if (invoice) {
            setIsPaidState(invoice.paid_status === 1);
            setLocalPaidRef(invoice.paid_ref_no || '');
            setLocalPaidDate(invoice.paid_datetime?.slice(0, 10) || '');
        }
    }, [invoice]);

    if (!invoice) {
        return <div className="text-center py-5 text-muted">No data found</div>;
    }

    const amounts = getCCInvoiceAmounts(invoice);

    return (
        <div className="tab-pane fade show active" id="viewjob-tab-pane1" role="tabpanel" tabIndex={0}>
            <div className="vr-inner">
                <div className="vr-top-invoice">
                    <div className="vrt-left">
                        <h3>Invoice Id</h3>
                        <p>{invoice.inv_no || '--'}</p>
                    </div>
                </div>

                <div className="vrt-content">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="vrt-split inv-padding">
                                <h3>Invoice Date</h3>
                                <p>{invoice.inv_datetime ? moment.utc(invoice.inv_datetime).local().format(DATE_FORMAT).slice(0, 10) : '--'}</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="vrt-split inv-padding">
                                <h3>Date Range</h3>
                                <p>{invoice.inv_start_date_only ? moment(invoice.inv_start_date_only, "YYYY-MM-DD").format(DATE_FORMAT).slice(0,10) : '--'} - {invoice.inv_end_date_only ? moment(invoice.inv_end_date_only, "YYYY-MM-DD").format(DATE_FORMAT).slice(0,10) : '--'}</p>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="vrt-split inv-padding">
                                <h3>Tax Percent</h3>
                                <p>
                                    {invoice.tax_rate !== null && invoice.tax_rate !== undefined
                                        ? `${(amounts.taxRate * 100).toFixed(2)}%`
                                        : '--'}
                                </p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="vrt-split inv-padding">
                                <h3>Tax Amount</h3>
                                <p>${amounts.taxAmount.toFixed(2)}</p>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="vrt-split inv-padding">
                                <h3>Base Amount</h3>
                                <p>${amounts.baseAmount.toFixed(2)}</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="vrt-split inv-padding">
                                <h3>Invoice Amount</h3>
                                <p>${amounts.grossAmount.toFixed(2)}</p>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="vrt-split inv-padding">
                                <h3>No Of Jobs</h3>
                                <p>{invoice.jobs_count}</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="vrt-split inv-padding">
                                <h3>Due Date</h3>
                                <p>{invoice.inv_due_date ? moment.utc(invoice.inv_due_date).local().format(DATE_FORMAT).slice(0, 10) : '--'}</p>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="vrt-split inv-padding">
                                <h3>Paid Status</h3>
                                <p>{isPaidState ? 'Paid' : 'Pending'}</p>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="vrt-split inv-padding">
                                <h3>Comments</h3>
                                <p>{invoice.paid_status === 1 ? invoice.paid_ref_no || '--' : '--'}</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="vrt-split inv-padding">
                                <h3>Paid Date</h3>
                                <p>{invoice.paid_status === 1 ? invoice.paid_datetime?.slice(0, 10) || '--' : '--'}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InvoiceDetailsTab;